module.exports = __webpack_public_path__ + "img/local_activity_opsz20B.dc85bc4e.svg";